<template>
  <div class="project-details">
    <el-form
      class="project-details-from"
      :rules="projectRentalCostsFromRules"
      ref="projectRentalCostsFrom"
      :model="projectRentalCostsFrom"
      label-width="100px"
    >
      <el-form-item label="仓库" prop="warehouseId">
        <el-select
          v-model="projectRentalCostsFrom.warehouseId"
          placeholder="请选择仓库"
          :disabled="isFlag === 3? true:false"
        >
          <el-option
            v-for="item in warehouseList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="实占面积" prop="useArea">
        <el-input
          @input="useAreaInput"
          v-model="projectRentalCostsFrom.useArea"
          placeholder="请输入实占面积"
          :disabled="isFlag != 1? true:false"
        ></el-input>
      </el-form-item>
      <el-form-item label="场租月单价" prop="rentPriceMonth">
        <el-input
          @input="rentPriceMonthInput"
          v-model="projectRentalCostsFrom.rentPriceMonth"
          placeholder="请输入场租月单价"
          :disabled="isFlag === 3? true:false"
        >
          <span slot="suffix">元/月</span>
        </el-input>
      </el-form-item>
      <el-form-item label="地推折算系数" prop="pileConversionFactor">
        <el-input
          @input="localConversionCoefficientInput"
          v-model="projectRentalCostsFrom.pileConversionFactor"
          placeholder="请输入地推折算系数"
          :disabled="isFlag === 3? true:false"
        >
          <span slot="suffix">个/平方米</span>
        </el-input>
      </el-form-item>
      <el-form-item label="货架折算系数" prop="shelfConversionFactor">
        <el-input
          @input="shelfConversionFactorInput"
          v-model="projectRentalCostsFrom.shelfConversionFactor"
          placeholder="请输入货架折算系数"
          :disabled="isFlag === 3? true:false"
        >
          <span slot="suffix">个/平方米</span>
        </el-input>
      </el-form-item>
      <el-form-item label="税率" prop="storageTaxRate">
        <el-input
          @input="taxRateInput"
          v-model="projectRentalCostsFrom.storageTaxRate"
          placeholder="示例：税率6%，填写0.06"
          :disabled="isFlag === 3? true:false"
        ></el-input>
      </el-form-item>

      <div class="switch-title">
        <p class="sub-title">场地优惠</p>
        <el-switch
          class="custom-switch"
          active-color="#2E68EA"
          :disabled="isFlag === 3"
          v-model="projectRentalCostsFrom.venueDiscounts"
          :active-text="projectRentalCostsFrom.venueDiscounts ? '开启优惠' : '关闭优惠'"
        >
        </el-switch>
      </div>
      <div 
        v-show="projectRentalCostsFrom.venueDiscounts"
        class="venue-discounts"
      >
        <div
          :class="[
            'venue-type-name',
            {
              'venue-active': item.id == projectRentalCostsFrom.venueDiscountsType
            }
          ]"
          v-for="(item, index) in venueDiscountsTypeList"
          :key="index"
          @click="selectVenueDiscountsType(item.id)"
        >
          {{ item.name }}
        </div>
      </div>
      <div v-show="projectRentalCostsFrom.venueDiscounts">
        <div class="row-item" v-if="projectRentalCostsFrom.venueDiscountsType == 1">
          <el-form-item label="约定坪效" prop="area">
            <el-input
            class="select-flag"
              @input="areaInput"
              v-model="projectRentalCostsFrom.area"
              :placeholder="!projectRentalCostsFrom.areaStatus ? '无需输入' : '请输入约定坪效'
                "
              :disabled="isFlag === 3 ? true : !projectRentalCostsFrom.areaStatus"
            >
            </el-input>
            <el-select
              class="w60"
              v-model="projectRentalCostsFrom.areaStatus"
              @change="changeAreaStatus"
              :disabled="isFlag === 3"
            >
              <el-option
                v-for="item in disabledList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="坪数规则"
            prop="areaUtilizationType"
            v-show="projectRentalCostsFrom.areaStatus"
          >
            <el-select
              v-model="projectRentalCostsFrom.areaUtilizationType"
              placeholder="请选择坪数规则"
              :disabled="isFlag === 3"
            >
              <el-option
                v-for="item in areaUtilization"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row-item" v-if="projectRentalCostsFrom.venueDiscountsType == 2">
          <el-form-item label="面积减免" prop="reduceArea">
            <el-input
              @input="areaReductionInput"
              v-model="projectRentalCostsFrom.reduceArea"
              placeholder="请输入面积减免"
            >
              <span slot="suffix">㎡</span>
            </el-input>
          </el-form-item>
        </div>
      </div>
      
      <div class="switch-title">
        <p class="sub-title">场地保底</p>
        <el-switch
          class="custom-switch"
          active-color="#2E68EA"
          :disabled="isFlag === 3"
          v-model="projectRentalCostsFrom.guaranteedRentPriceStatus"
          :active-text="projectRentalCostsFrom.guaranteedRentPriceStatus?'开启保底':'关闭保底'"
        >
        </el-switch>
      </div>
      <div class="row-item" v-if="projectRentalCostsFrom.guaranteedRentPriceStatus">
        <el-form-item label="场地保底" prop="guaranteedRentPrice">
          <el-input
            class="select-minimum-guarantee"
            @input="guaranteedRentPriceInput"
            v-model="projectRentalCostsFrom.guaranteedRentPrice"
            placeholder="请输入"
            :disabled="isFlag === 3"
            :rules="[
              { required: projectRentalCostsFrom.guaranteedRentPriceStatus ? true : false, message: '请输入场地保底', trigger: 'blur' }
            ]"
          >
            <span
              slot="suffix"
              >元/月</span
            >
          </el-input>
          <el-select
            class="w120"
            v-model="projectRentalCostsFrom.guaranteedRentPriceType"
            :disabled="isFlag === 3"
          >
            <el-option
              v-for="item in guaranteedRentPriceList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
    </el-form>
    <div class="project-details-footer" v-if="isFlag === 2">
      <el-button class="btn-blue" @click="saveProjectRentalCosts('projectRentalCostsFrom')">保存</el-button>
    </div>
  </div>
</template>

<script>
import ProjectManage from "models/project-manage";
const projectManage = new ProjectManage();
import { getDecimal } from "common/js/util";
import warehouseMixins from "@/common/mixins/warehouse.js"
import projectManageMixins from "@/common/mixins/project-manage.js"
export default {
  mixins: [warehouseMixins, projectManageMixins],
  props: ['parentProjectRentalCostsFrom'],

  data() {
    return {
      isFlag: null,
      projectRentalCostsFrom: this.parentProjectRentalCostsFrom,
      venueDiscountsTypeList: [
        { id: 1, name: '约定坪效' },
        { id: 2, name: '面积减免' }
      ],
      projectRentalCostsFromRules: {
        warehouseId: [
          { required: true, message: "请选择仓库", trigger: "change" },
        ],
        useArea: [
          { required: true, message: "请输入实占面积", trigger: "blur" },
        ],
        pileConversionFactor: [
          { required: true, message: "请输入地堆折算系数", trigger: "blur" },
        ],
        shelfConversionFactor: [
          { required: true, message: "请输入货架折算系数", trigger: "blur" },
        ],
        storageTaxRate: [{ required: true, message: "请输入税率", trigger: "blur" }],
        rentPriceMonth: [
          { required: true, message: "请输入场租月单价", trigger: "blur" },
        ],
      }
    }
  },

  created() {
    this.isFlag = Number(this.$route.query.isFlag);
    this.initWarehouse()
  },
  mounted() {
    this.$bus.on('projectRentalCostsFrom', v => {
      this.projectRentalCostsFrom = v
    })
  },

  methods: {
    saveProjectRentalCosts(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let id = Number(this.$route.query.projectId);
          let warehouseId = this.projectRentalCostsFrom.warehouseId
          let useArea = this.projectRentalCostsFrom.useArea
          let guaranteedRentPrice = 0
          // 场地保底
          if (this.projectRentalCostsFrom.guaranteedRentPriceStatus) {
            guaranteedRentPrice =
              this.projectRentalCostsFrom.guaranteedRentPrice
              ? this.projectRentalCostsFrom.guaranteedRentPrice
                : 0;
          }
          let rentPriceMonth = this.projectRentalCostsFrom.rentPriceMonth
          let areaUtilization = this.projectRentalCostsFrom.area
          let areaUtilizationType = this.projectRentalCostsFrom.areaUtilizationType
          let pileConversionFactor = this.projectRentalCostsFrom.pileConversionFactor === "" ? 0 : Number(this.projectRentalCostsFrom.pileConversionFactor)
          let shelfConversionFactor = this.projectRentalCostsFrom.shelfConversionFactor === "" ? 0 : Number(this.projectRentalCostsFrom.shelfConversionFactor)
          let storageTaxRate = this.projectRentalCostsFrom.storageTaxRate;
          // 场地优惠
          let rentDiscount = 0
          if (this.projectRentalCostsFrom.venueDiscounts) {
            rentDiscount = this.projectRentalCostsFrom.venueDiscountsType
          }
          let reduceArea = this.projectRentalCostsFrom.reduceArea === "" ? 0 : Number(this.projectRentalCostsFrom.reduceArea)
          let data = {
            id,
            warehouseId,
            useArea,
            guaranteedRentPrice,
            rentPriceMonth,
            areaUtilization,
            areaUtilizationType,
            pileConversionFactor,
            shelfConversionFactor,
            storageTaxRate,
            rentDiscount,
            reduceArea
          }
          projectManage.postUpdateProjectRentalCosts(data).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '场租计费规则编辑成功'
              })
            } else {
              this.$message({
                type: 'error',
                message: res.message
              })
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      })
    },
    changeAreaStatus() {
      if (!this.projectRentalCostsFrom.areaStatus) {
        this.projectRentalCostsFrom.area = ''
        this.projectRentalCostsFrom.areaUtilizationType = ''
      }
    },
    /* 实占面积 */
    useAreaInput() {
      let useArea = this.projectRentalCostsFrom.useArea;
      this.projectRentalCostsFrom.useArea = getDecimal(useArea);
    },
    /* 坪数限制 */
    areaInput() {
      let area = this.projectRentalCostsFrom.area;
      this.projectRentalCostsFrom.area = getDecimal(area);
    },
    /* 场租月单价限制 */
    rentPriceMonthInput() {
      let rentPriceMonth = this.projectRentalCostsFrom.rentPriceMonth;
      this.projectRentalCostsFrom.rentPriceMonth = getDecimal(rentPriceMonth);
    },
    /* 地推折算系数 */
    localConversionCoefficientInput() {
      let pileConversionFactor = this.projectRentalCostsFrom.pileConversionFactor;
      this.projectRentalCostsFrom.pileConversionFactor = getDecimal(pileConversionFactor);
    },
    /* 货架折算系数 */
    shelfConversionFactorInput() {
      let shelfConversionFactor = this.projectRentalCostsFrom.shelfConversionFactor;
      this.projectRentalCostsFrom.shelfConversionFactor = getDecimal(shelfConversionFactor);
    },
    /* 月场租保底限制 */
    guaranteedRentPriceInput() {
      let guaranteedRentPrice = this.projectRentalCostsFrom.guaranteedRentPrice;
      this.projectRentalCostsFrom.guaranteedRentPrice = getDecimal(guaranteedRentPrice);
    },
    /* 限制税率 */
    taxRateInput() {
      let storageTaxRate = this.projectRentalCostsFrom.storageTaxRate;
      this.projectRentalCostsFrom.storageTaxRate = getDecimal(storageTaxRate);
    },
    /* 面积减免限制 */
    areaReductionInput() {
      let reduceArea = this.projectRentalCostsFrom.reduceArea;
      this.projectRentalCostsFrom.reduceArea = getDecimal(reduceArea);
    },

    /** 
     * @desc 选择场地优惠类型
     * @param {*} id 场地优惠类型id
    */
    selectVenueDiscountsType(id) {
      if (this.isFlag !== 3) this.projectRentalCostsFrom.venueDiscountsType = id
    }
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/project/project-details.scss';
</style>
